import type { ProductDto } from '@utility-nyc/react-query-sdk';

import { getShortMonthName } from './getShortMonthName';

const formattedProductName = (product: ProductDto) =>
  `${product.name} ${product.coupon} ${getShortMonthName(product.month)}`;

export { formattedProductName };
